import Joi from 'joi';

export const validateEmail = (email: string) => {
    if (email.length > 250) return false;
    if (!email.trim()) return false;

    const validatedEmail = Joi.string()
        .email({ tlds: { allow: false } })
        .validate(email);

    return !validatedEmail.error;
};

export const validatePassword = (password: string) => {
    if (password && password.length > 20) return false;
    if (password && !password.trim()) return false;

    return password && password.match(/^(?=.*\d)\S{8,20}$/);
};

export const validatePhoneNumber = (phoneNumber: string) => {
    if (phoneNumber?.length > 20) return false;
    if (!phoneNumber?.trim()) return false;

    return phoneNumber.match(/^\+[0-9]{8,20}$/g);
};

export const validateNumbers = (input: string) => {
    return /^[0-9]+$/.test(input);
};

export const validateUrl = (urlString: string | undefined) => {
    const urlPattern = new RegExp(
        '^(https?:\\/\\/)?' + // validate protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
            '(\\#[-a-z\\d_]*)?$',
        'i',
    ); // validate fragment locator

    return urlPattern.test(urlString as string);
};
